import { useContext } from 'react';
import { ServicesContext, ServiceContextState } from '@insync-students-stores/servicesContext';
export function useServices(): Partial<ServiceContextState> {
  const context = useContext(ServicesContext);
  if (context === undefined) {
    throw new Error('useServices context must be used within a Provider');
  }
  return context;
}